<proffeo-ui-dialog [title]="'final-cost-modal.title' | translate">
  <form
    [formRoot]="finalCostForm"
    class="flex w-full flex-col"
  >
    <div class="flex gap-4 py-4">
      <mat-icon
        fontIcon="timer"
        class="icon-muted"
      />
      <div class="flex min-w-0 flex-1 flex-col gap-2">
        <p class="m-0 font-semibold">
          {{ 'final-cost-modal.time' | translate }}
        </p>
        <div class="flex items-start gap-2">
          <proffeo-ui-input
            [formField]="finalCostForm.time.amount"
            type="number"
            class="min-w-0 flex-1"
          >
            <p proffeoUiInputError>{{ 'ui-forms-the-minimum-value-is' | translate }} 0</p>
          </proffeo-ui-input>
          <proffeo-ui-select
            [formField]="finalCostForm.time.units"
            [options]="timeUnitOptions"
            class="w-40 shrink-0"
          />
        </div>
      </div>
    </div>

    <div class="flex gap-4 py-4">
      <mat-icon
        fontIcon="paid"
        class="icon-muted"
      />
      <div class="flex min-w-0 flex-1 flex-col gap-2">
        <p class="m-0 font-semibold">
          {{ 'final-cost-modal.financial' | translate }}
        </p>
        <div class="flex items-start gap-2">
          <proffeo-ui-input
            [formField]="finalCostForm.financial.amount"
            type="number"
            class="min-w-0 flex-1"
          >
            <p proffeoUiInputError>{{ 'ui-forms-the-minimum-value-is' | translate }} 0</p>
          </proffeo-ui-input>
          <proffeo-ui-select
            [formField]="finalCostForm.financial.currency"
            [options]="currencyOptions"
            [translateLabels]="false"
            class="w-40 shrink-0"
          />
        </div>
      </div>
    </div>

    <div class="flex gap-4 py-4">
      <mat-icon
        fontIcon="package_2"
        class="icon-muted"
      />
      <div class="flex min-w-0 flex-1 flex-col gap-2">
        <p class="m-0 font-semibold">
          {{ 'final-cost-modal.quantity' | translate }}
        </p>
        <div class="flex items-start gap-2">
          <proffeo-ui-input
            [formField]="finalCostForm.quantity.amount"
            type="number"
            class="min-w-0 flex-1"
          >
            <p proffeoUiInputError>{{ 'ui-forms-the-minimum-value-is' | translate }} 0</p>
          </proffeo-ui-input>
          <proffeo-ui-select
            [formField]="finalCostForm.quantity.units"
            [options]="quantityUnitOptions"
            class="w-40 shrink-0"
          />
        </div>
      </div>
    </div>
  </form>

  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      (clicked)="cancelFinalCost()"
      variant="secondary"
      mat-dialog-close
      text="companies-cancel"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="saveFinalCost()"
      variant="accent"
      text="companies-save"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
